import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import AntCarousel from 'antd/lib/carousel';
import './style';

const propTypes = {
  className: PropTypes.string,
  getSliderRef: PropTypes.func,
  ...AntCarousel.propTypes,
};

class Carousel extends React.Component {
  render() {
    const { className, getSliderRef, ...rest } = this.props;
    const computedClassName = classNames('bsa-carousel', className);
    const props = {
      className: computedClassName,
      ...rest,
    };
    if (getSliderRef) {
      props.ref = c => getSliderRef(c);
    }
    return (
      <AntCarousel
        {...props}
      />
    );
  }
}

Carousel.defaultProps = AntCarousel.defaultProps;
Carousel.propTypes = propTypes;
export default Carousel;
